import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "manageSARDetails",
  class: "pt-gutter pb-gutter bodydynamic"
}
const _hoisted_2 = {
  key: 0,
  class: "mb-gutter"
}
const _hoisted_3 = {
  key: 0,
  class: "alert alert--error"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-alert" }, null, -1)
const _hoisted_5 = { class: "list-styled" }
const _hoisted_6 = {
  key: 1,
  class: "alert alert--error"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-alert" }, null, -1)
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_SAREdit = _resolveComponent("v-SAREdit")!
  const _component_v_usercontactdetails = _resolveComponent("v-usercontactdetails")!
  const _component_v_usercontactdetailsv2 = _resolveComponent("v-usercontactdetailsv2")!
  const _component_v_usercontactdetailsv3 = _resolveComponent("v-usercontactdetailsv3")!
  const _component_v_usercontactdetailsv4 = _resolveComponent("v-usercontactdetailsv4")!
  const _component_v_usercontactdetailsv5 = _resolveComponent("v-usercontactdetailsv5")!
  const _component_v_usercontactdetailsv6 = _resolveComponent("v-usercontactdetailsv6")!
  const _component_v_usercontactdetailsv7 = _resolveComponent("v-usercontactdetailsv7")!
  const _component_v_userrelationship = _resolveComponent("v-userrelationship")!
  const _component_v_userrelationshipv2 = _resolveComponent("v-userrelationshipv2")!
  const _component_v_userrelationshipv4 = _resolveComponent("v-userrelationshipv4")!
  const _component_v_userrelationshipv5 = _resolveComponent("v-userrelationshipv5")!
  const _component_v_usercctvdetails = _resolveComponent("v-usercctvdetails")!
  const _component_v_usercctvdetailsv2 = _resolveComponent("v-usercctvdetailsv2")!
  const _component_v_usercctvdetailsv3 = _resolveComponent("v-usercctvdetailsv3")!
  const _component_v_usercctvdetailsv4 = _resolveComponent("v-usercctvdetailsv4")!
  const _component_v_usercctvdetailsv5 = _resolveComponent("v-usercctvdetailsv5")!
  const _component_v_userattachmentdetails = _resolveComponent("v-userattachmentdetails")!
  const _component_v_userattachmentdetailsv2 = _resolveComponent("v-userattachmentdetailsv2")!
  const _component_v_userattachmentdetailsv4 = _resolveComponent("v-userattachmentdetailsv4")!
  const _component_v_userattachmentdetailsv6 = _resolveComponent("v-userattachmentdetailsv6")!
  const _component_v_userattachmentdetailsv7 = _resolveComponent("v-userattachmentdetailsv7")!
  const _component_v_userattachmentdetailsv8 = _resolveComponent("v-userattachmentdetailsv8")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", null, [
      (_ctx.initModel.modelErrors.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.authModel.isRequestAuthorized)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _hoisted_4,
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("validationtext.validationHeading")), 1)
                  ]),
                  _createElementVNode("ul", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.modelErrors, (error, index) => {
                      return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(error), 1))
                    }), 128))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.initModel.modelErrors, (error, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(error), 1))
                  }), 128))
                ]))
          ]))
        : _createCommentVNode("", true),
      (_ctx.initModel.modelErrors.length)
        ? (_openBlock(), _createElementBlock("br", _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.authModel.isRequestAuthorized && _ctx.showReviewComponent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createVNode(_component_v_SAREdit, {
              initModel: _ctx.initModel,
              sarLegalMgmt: _ctx.newSARLegalMgmt,
              sargridsearchTaskResultFromParent: _ctx.searchTaskResult,
              showtaskgrid: _ctx.enableTaskGrid,
              onSarMgmtAddNewTask: _ctx.addNewTask,
              sarLegalTask: _ctx.sarLegalMgmtTask,
              onSarMgmtConsentHistory: _ctx.getConsentHistory,
              sarConsentHstryGrid: _ctx.consentHistoryGridDetails,
              showConsentHstryGrid: _ctx.enableConsentHstryGrid,
              sarConsentHistoryDataModel: _ctx.sarConsentHistryModel,
              consentHistoryDownloadOptions: _ctx.consentHistoryDownloadOptions,
              sarLegalNotes: _ctx.sarLegalMgmtNotes,
              onSarMgmttUpdate: _ctx.saveSarMgmtChanges,
              onSarMgmtNotesUpdate: _ctx.saveSarNotes,
              onShowValidationMessageEventFromChild: _ctx.showErrorMessageForFileUpload,
              onFileDownloadEventFromChild: _ctx.downloadAttachments
            }, null, 8, ["initModel", "sarLegalMgmt", "sargridsearchTaskResultFromParent", "showtaskgrid", "onSarMgmtAddNewTask", "sarLegalTask", "onSarMgmtConsentHistory", "sarConsentHstryGrid", "showConsentHstryGrid", "sarConsentHistoryDataModel", "consentHistoryDownloadOptions", "sarLegalNotes", "onSarMgmttUpdate", "onSarMgmtNotesUpdate", "onShowValidationMessageEventFromChild", "onFileDownloadEventFromChild"]),
            _withDirectives(_createVNode(_component_v_usercontactdetails, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            !_ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA)
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv2, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 2
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv3, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 3
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv4, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 4
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv5, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 5
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv6, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 6
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercontactdetailsv7, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser,
              styleCode: _ctx.styleId
            }, null, 8, ["initModel", "newUser", "styleCode"]), [
              [_vShow, 
            _ctx.styleId &&
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartA) &&
            _ctx.userContactDetailsVersion == 7
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userrelationship, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            !_ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartB)
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userrelationshipv2, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartB) &&
            _ctx.userCustEmpRelationshipVersion == 2
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userrelationshipv4, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartB) &&
            _ctx.userCustEmpRelationshipVersion == 4
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userrelationshipv5, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser,
              styleCode: _ctx.styleId
            }, null, 8, ["initModel", "newUser", "styleCode"]), [
              [_vShow, 
            _ctx.styleId &&
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartB) &&
            _ctx.userCustEmpRelationshipVersion == 5
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetails, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            !_ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC)
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetailsv2, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC) &&
            _ctx.userCCTVDetailsVersion == 2
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetailsv3, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC) &&
            _ctx.userCCTVDetailsVersion == 3
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetailsv4, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC) &&
            _ctx.userCCTVDetailsVersion == 4
          ]
            ]),
            _withDirectives(_createVNode(_component_v_usercctvdetailsv5, {
              initModel: _ctx.initModel,
              newUser: _ctx.newUser
            }, null, 8, ["initModel", "newUser"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartC) &&
            _ctx.userCCTVDetailsVersion == 5
          ]
            ]),
            (_ctx.newUser.DocumentList.length !== 0)
              ? _withDirectives((_openBlock(), _createBlock(_component_v_userattachmentdetails, {
                  key: 0,
                  newUser: _ctx.newUser,
                  initModel: _ctx.initModel,
                  onEmmitedFileName: _ctx.downloadAttachments
                }, null, 8, ["newUser", "initModel", "onEmmitedFileName"])), [
                  [_vShow, 
            !_ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartE)
          ]
                ])
              : _createCommentVNode("", true),
            (_ctx.newUser.DocumentList.length !== 0)
              ? _withDirectives((_openBlock(), _createBlock(_component_v_userattachmentdetailsv2, {
                  key: 1,
                  newUser: _ctx.newUser,
                  initModel: _ctx.initModel,
                  onEmmitedFileName: _ctx.downloadAttachments
                }, null, 8, ["newUser", "initModel", "onEmmitedFileName"])), [
                  [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartE) &&
            _ctx.userAttachmentDetailsVersion == 2
          ]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_v_userattachmentdetailsv4, {
              newUser: _ctx.newUser,
              initModel: _ctx.initModel,
              onEmmitedFileName: _ctx.downloadAttachments
            }, null, 8, ["newUser", "initModel", "onEmmitedFileName"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartE) &&
            _ctx.userAttachmentDetailsVersion == 4
          ]
            ]),
            _withDirectives(_createVNode(_component_v_userattachmentdetailsv6, {
              newUser: _ctx.newUser,
              initModel: _ctx.initModel,
              onEmmitedFileName: _ctx.downloadAttachments
            }, null, 8, ["newUser", "initModel", "onEmmitedFileName"]), [
              [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartE) &&
            _ctx.userAttachmentDetailsVersion == 6
          ]
            ]),
            (_ctx.newUser.DocumentList.length !== 0)
              ? _withDirectives((_openBlock(), _createBlock(_component_v_userattachmentdetailsv7, {
                  key: 2,
                  newUser: _ctx.newUser,
                  initModel: _ctx.initModel,
                  onEmmitedFileName: _ctx.downloadAttachments
                }, null, 8, ["newUser", "initModel", "onEmmitedFileName"])), [
                  [_vShow, 
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartE) &&
            _ctx.userAttachmentDetailsVersion == 7
          ]
                ])
              : _createCommentVNode("", true),
            (_ctx.newUser.DocumentList.length !== 0)
              ? _withDirectives((_openBlock(), _createBlock(_component_v_userattachmentdetailsv8, {
                  key: 3,
                  newUser: _ctx.newUser,
                  initModel: _ctx.initModel,
                  onEmmitedFileName: _ctx.downloadAttachments,
                  styleCode: _ctx.styleId
                }, null, 8, ["newUser", "initModel", "onEmmitedFileName", "styleCode"])), [
                  [_vShow, 
            _ctx.styleId &&
            _ctx.isComponentVersionUpdateRequired(_ctx.childComponentSection.PartE) &&
            _ctx.userAttachmentDetailsVersion == 8
          ]
                ])
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}